import useFlags from "@/hooks/use-flags"
import {
  Select,
  SelectContent,
  SelectGroup,
  SelectTrigger,
  SelectItem,
} from "@/components/ui/select"
import { useCosmos } from "@/modules/cosmos/stores/use-cosmos-store"
import { COSMOS_KEY } from "@/modules/cosmos/entities/cosmos"
import { cosmosConfig } from "@/modules/cosmos/constants/cosmos"

export default function CosmosSelector() {
  const { cosmosSelector: canShowCosmosSelector } = useFlags()
  const { cosmosKey, setCosmos } = useCosmos()
  const cosmosKeys = Object.values(COSMOS_KEY)

  const handleOnChange = (newCosmosKey: COSMOS_KEY) => {
    const newCosmosConfig = cosmosConfig[newCosmosKey]

    setCosmos({
      cosmosKey: newCosmosKey,
      cosmos: newCosmosConfig,
    })
  }

  if (!canShowCosmosSelector) return null

  return (
    <Select value={cosmosKey} onValueChange={handleOnChange}>
      <SelectTrigger className="w-auto overflow-hidden">
        <div className="mr-3 flex items-center justify-center gap-3 overflow-hidden">
          <span>{cosmosKey}</span>
        </div>
      </SelectTrigger>
      <SelectContent>
        <SelectItem disabled value="placeholder">
          Seleccione un cosmos
        </SelectItem>
        <SelectGroup>
          {cosmosKeys.map((cosmosKey) => (
            <SelectItem value={cosmosKey} key={cosmosKey}>
              {cosmosKey}
            </SelectItem>
          ))}
        </SelectGroup>
      </SelectContent>
    </Select>
  )
}
